import BreathingUpdateRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/BreathingService/BreathingUpdateRequest";
import BreathingTranslateViewModel from "./breathingTranslateViewModel";
import BreathingGetDetailResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/BreathingService/BreathingGetDetailResponse";

export default class CreateBreathingViewModel {
    id?: number = null;
	backgroundFileId: string = '';
	backgroundFileUrl: string = '';
	inhalation: number = 0;
	exhalation: number = 0;
	breathHoldingFirst: number = 0;
	breathHoldingSecond: number = 0;
	repeatCount: number = 0;
	translations: Array<BreathingTranslateViewModel> = null;
	isPaid: boolean = false;
	initLanguages(languages: string[]) {
		this.translations = languages.map(
			(x) =>
			  new BreathingTranslateViewModel({
				langCode: x
			  })
		  );
	}
	toServerModel(): BreathingUpdateRequest {
		const req = new BreathingUpdateRequest({
			Id: this.id,
			IsPaid: this.isPaid,
			BackgroundFileId: this.backgroundFileId,
			BreathHoldingFirst: this.breathHoldingFirst,
			BreathHoldingSecond: this.breathHoldingSecond,
			Exhalation: this.exhalation,
			Inhalation: this.inhalation,
			RepeatCount: this.repeatCount,
			Translations: this.translations.map(x=>x.toServerModel())
		});
		return req;
	}
	fromServerModel(model: BreathingGetDetailResponse) {
		this.id = model.Id;
		// console.log('fromServerModel: ', model);
		
		this.backgroundFileId = model.BackgroundFileId;
		this.inhalation = model.Inhalation;
		this.exhalation = model.Exhalation;
		this.isPaid= model.IsPaid;
		this.breathHoldingFirst = model.BreathHoldingFirst;
		this.breathHoldingSecond = model.BreathHoldingSecond;
		this.repeatCount = model.RepeatCount;
		this.translations.forEach(tr => {
			const serverTranslation = model.Translations.find(x=>x.LangCode == tr.langCode);
			if (serverTranslation != null) {
				tr.id = serverTranslation.Id;
				tr.name = serverTranslation.Name;
				tr.categoryName = serverTranslation.CategoryName;
				tr.description = serverTranslation.Description;
			}
		});
	}
}
